import { render, staticRenderFns } from "./ParamsSetting.vue?vue&type=template&id=07a0a548&scoped=true"
import script from "./ParamsSetting.vue?vue&type=script&lang=js"
export * from "./ParamsSetting.vue?vue&type=script&lang=js"
import style0 from "./ParamsSetting.vue?vue&type=style&index=0&id=07a0a548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0a548",
  null
  
)

export default component.exports